import {useNavigate} from 'react-router-dom';
import {Alert, AlertDescription} from '@/components/ui/alert.tsx';
import {Button} from '@/components/ui/button.tsx';
import {Tabs, TabsContent, TabsList, TabsTrigger} from '@/components/ui/tabs.tsx';
import {LoadingSpinner} from '../../../components/LoadingSpinner';
import {PeriodPicker} from '../../../components/period-picker/period-picker';
import {UnitEconomicsWaterfall} from '../unit-economics-page/waterfall/unit-economics-waterfall';
import {pageContentClassName} from '../../../ui/pageContentClass';
import {SkuContributionWaterfall} from './sku-contribution-waterfall';
import {StoreEconomicsNotices} from './store-economics-notices';
import {useStoreEconomicsPage} from './use-store-economics-page';

export function StoreEconomicsPage() {
	const navigate = useNavigate();
	const state = useStoreEconomicsPage();

	return (
		<div className={pageContentClassName}>
			<div className="mb-4 flex items-center justify-between gap-3">
				<h1 className="text-xl font-semibold tracking-tight">Экономика магазина</h1>
				<Button type="button" variant="ghost" size="sm" onClick={() => navigate('/ozon')}>
					Назад
				</Button>
			</div>

			<div className="flex flex-col gap-3">
				<PeriodPicker {...state.period} dateFieldIdPrefix="store-economics" />

				{state.error && (
					<Alert variant="destructive">
						<AlertDescription>{state.error}</AlertDescription>
					</Alert>
				)}
				{state.loading && <LoadingSpinner compact/>}
				{!state.loading && state.data && !state.hasSales && !state.error && (
					<p className="text-sm text-muted-foreground">За период нет продаж</p>
				)}
				{!state.loading && state.data && state.hasSales && (
					<Tabs defaultValue="totals">
						<TabsList className="w-full">
							<TabsTrigger value="totals" className="flex-1">Общая экономика</TabsTrigger>
							<TabsTrigger value="skus" className="flex-1">Вклад по SKU</TabsTrigger>
						</TabsList>
						<TabsContent value="totals" className="mt-3 flex flex-col gap-3">
							{state.waterfallRow ? (
								<UnitEconomicsWaterfall
									row={state.waterfallRow}
									showPerUnit={false}
									reportingPeriod={{from: state.data.totals.from, to: state.data.totals.to}}
								/>
							) : null}
						</TabsContent>
						<TabsContent value="skus" className="mt-3 flex flex-col gap-3">
							{state.data.skus.length === 0 ? (
								<p className="text-sm text-muted-foreground">За период нет продаж по SKU</p>
							) : (
								<SkuContributionWaterfall rows={state.data.skus} skuLabels={state.skuLabels}/>
							)}
						</TabsContent>
					</Tabs>
				)}
				{!state.loading && state.data?.notices.length ? (
					<StoreEconomicsNotices
						notices={state.data.notices}
						skuLabels={state.skuLabels}
						periodFrom={state.data.totals.from}
						catalog={state.catalog ?? []}
					/>
				) : null}
			</div>
		</div>
	);
}
